import { render, staticRenderFns } from "./Fundamentals.vue?vue&type=template&id=2980c10c&"
import script from "./Fundamentals.vue?vue&type=script&lang=js&"
export * from "./Fundamentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports